import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
interface CheckListProps {
  items: string[];
  variant?: 'check' | 'x';
}
export function CheckList({
  items,
  variant = 'check'
}: CheckListProps) {
  const Icon = variant === 'check' ? CheckIcon : XIcon;
  const iconColor = variant === 'check' ? 'text-green-600' : 'text-red-500';
  const bgColor = variant === 'check' ? 'bg-green-50' : 'bg-red-50';
  return <ul className="space-y-3" data-id="element-1">
      {items.map((item, index) => <li key={index} className={`flex items-start gap-3 ${bgColor} p-3 rounded-lg`} data-id="element-2">
          <Icon className={`${iconColor} flex-shrink-0 mt-0.5`} size={20} data-id="element-3" />
          <span className="text-gray-800" data-id="element-4">{item}</span>
        </li>)}
    </ul>;
}